module.exports = __webpack_public_path__ + "img/user_manage.7b09c157.png";